import type { AdminRole } from '@/lib/api-admin';

/**
 * RBAC — user-service AdminMileage/AdminDeposit/AdminMileageEarnPolicy 컨트롤러 @PreAuthorize 정합.
 * 읽기(list/detail/balance/내역/만료/출금목록): SUPER_ADMIN/OPS_ADMIN/CS_AGENT/AUDITOR.
 * 쓰기(정책 CRUD/markDefault, 수동·일괄 지급/차감, 출금 승인/지급/반려): SUPER_ADMIN/OPS_ADMIN.
 * by-product set/replace 는 BE 가 MD_MANAGER 도 허용하지만, 라우트 가드는 보수적으로 OPS 이상으로 둔다.
 */
export const MILEAGE_READ_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'OPS_ADMIN',
  'CS_AGENT',
  'AUDITOR',
];

export const MILEAGE_WRITE_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN', 'OPS_ADMIN'];
